import createImmutableSelector from 'lib/immutable/selector'
import { IUser } from '../models'

// TODO: import Store type and add reducer type in Store interface
const getUser = (state: any): IUser => state.get('userReducer')

export const userSelector = createImmutableSelector(getUser, (user) => user)
